import { CommonModule } from "@angular/common";
import { Component, computed, inject, input } from "@angular/core";
import { Router } from "@angular/router";
import { DocumentDto } from "@malirang/api-client";
import { DocumentEtcType, DocumentStatus } from "@malirang/common";
import { Icon, ModalService, ScreenSizeService } from "@malirang/front-share";
import { injectParams } from "ngxtension/inject-params";
import { injectQueryParams } from "ngxtension/inject-query-params";
import { environment } from "../../../../../env/env";
import {
    FixDocumentContentModal,
    FixDocumentContentModalProps,
} from "../../pages/fix-document/fix-document-content/fix-document-content.modal";

@Component({
    selector: "app-etc-document-card",
    templateUrl: "./etc-document-card.html",
    styleUrls: ["./etc-document-card.css"],
    imports: [CommonModule, Icon],
})
export class EtcDocumentCard {
    readonly router = inject(Router);
    readonly modalService = inject(ModalService);
    readonly screenSizeService = inject(ScreenSizeService);

    document = input.required<DocumentDto>();
    documentId = injectParams("documentId");
    ticketId = injectQueryParams("ticketId");
    centerChildId = injectQueryParams("centerChildId");
    type = injectQueryParams("type");
    etcType = DocumentEtcType;

    lock = environment.state !== "local";

    status = computed(() => {
        if (this.document()) {
            return this.document()!.status;
        }

        return DocumentStatus.PENDING;
    });

    isActive = computed(() => this.documentId() === this.document()?.id);

    handleDetail() {
        if (this.lock) {
            return;
        }

        if (this.document()) {
            const documentId = this.document()!.id;

            // 모바일/태블릿에서는 모달로 표시
            if (this.screenSizeService.isTabletOrMobile() && documentId) {
                this.modalService.create<FixDocumentContentModalProps>(
                    FixDocumentContentModal,
                    {
                        componentProps: {
                            documentId: documentId,
                        },
                    },
                );
                return;
            }

            // 상태와 관계없이 항상 detail 페이지로 이동
            this.router.navigate([`/document/document-box/etc/${documentId}`], {
                queryParams: {
                    type: this.document()!.etcType,
                    phase: "ETC",
                },
                queryParamsHandling: "merge",
                replaceUrl: true,
            });
        }
    }
}
